import { styled } from '@mui/material/styles';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export { SplitModal as Modal, PreviewWrapper } from '@components/SplitModal';

export const FormWrapper = styled('div')({
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'initial',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
    },
});

export const RadioButtonsWrapper = styled('div')({
    overflowX: 'initial',
    height: 32,
    marginBottom: 24,
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    '@media (max-width: 768px)': {
        overflowX: 'auto',
    },
});

export const RadioButtons = styled(RadioButtonsGroup)({
    width: '100%',
    display: 'block',
    '& .MuiFormControlLabel-root': {
        height: 32,
        padding: '0 4px',
    },
});

export const CheckboxRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    transform: 'translateX(-7px)',
    '& .MuiCheckbox-root': {
        padding: 4,
    },
});

export const TwoColumnsForm = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gridGap: 16,
    margin: '8px 0',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: 0,
    },
});
